import React, { useLayoutEffect, useState } from 'react';
import { View, Text, StyleSheet, ScrollView, TouchableOpacity } from 'react-native';
import FontSizes from '../../constants/FontSizes';
import { MainColors } from '../../constants/Colors';
import VotingAliasModal from './components/VotingAliasModal';
import EmailAddressModal from './components/EmailAddressModal';
import PasswordModal from './components/PasswordModal';
import Constants from "expo-constants";

const SettingsScreen = ({ navigation }) => {
    const [isAliasModalVisible, setIsAliasModalVisible] = useState(false);
    const [isEditEmailModalVisible, setIsEditEmailModalVisible] = useState(false);
    const [isPasswordModalVisible, setIsPasswordModalVisible] = useState(false);
    const version = Constants.manifest.version;

    useLayoutEffect(() => {
        navigation.setOptions({
            headerTitle: 'Settings',
            headerLeft: null
        });
    }, [navigation]);

    return (
        <>
            <ScrollView style={styles.screen}>
                <View style={styles.contentContainer}>
                    <View style={styles.headerContainer}>
                        <Text style={styles.headerText}>Account Management</Text>
                    </View>
                    <View style={styles.listItemContainer}>
                        <TouchableOpacity onPress={() => setIsAliasModalVisible(true)}>
                            <Text style={styles.listItem}>See Voting Alias</Text>
                        </TouchableOpacity>
                    </View>
                    <View style={styles.listItemContainer}>
                        <TouchableOpacity onPress={() => { setIsPasswordModalVisible(true) }}>
                            <Text style={styles.listItem}>Change Password</Text>
                        </TouchableOpacity>
                    </View>
                    <View style={styles.listItemContainer}>
                        <TouchableOpacity onPress={() => setIsEditEmailModalVisible(true)}>
                            <Text style={styles.listItem}>Change Email Address</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </ScrollView>
            <VotingAliasModal
                visible={isAliasModalVisible}
                onModalBackgroundPressed={() => setIsAliasModalVisible(false)}
                onCloseButtonPressed={() => setIsAliasModalVisible(false)}
            />
            <EmailAddressModal
                visible={isEditEmailModalVisible}
                onModalBackgroundPressed={() => setIsEditEmailModalVisible(false)}
                onCloseButtonPressed={() => setIsEditEmailModalVisible(false)}
                onEmailUpdateCompleted={() => setIsEditEmailModalVisible(false)}
            />
            <PasswordModal
                visible={isPasswordModalVisible}
                onModalBackgroundPressed={() => setIsPasswordModalVisible(false)}
                onCloseButtonPressed={() => setIsPasswordModalVisible(false)}
                onSavePasswordSuccess={() => setIsPasswordModalVisible(false)}
            />
            <View style={styles.appDetailsContainer}>
                <Text style={styles.appDetailsText}>Votl version {version}</Text>
                <Text style={styles.appDetailsText}>Copyright &copy; 2021 </Text>
            </View>
        </>
    )
}

const styles = StyleSheet.create({
    screen: {
        flex: 1
    },
    contentContainer: {
        paddingVertical: 30,
        paddingHorizontal: 20
    },
    headerContainer: {
        marginBottom: 12,
        paddingBottom: 8,
        borderBottomWidth: 1,
        borderBottomColor: MainColors.faintGray,
    },
    headerText: {
        color: MainColors.mediumGray,
        fontSize: FontSizes.medium,
        fontWeight: '500',
        letterSpacing: 0.5
    },
    listItemContainer: {
        paddingBottom: 12
    },
    listItem: {
        marginLeft: 15,
        fontSize: FontSizes.medium,
        color: MainColors.primary,
        fontWeight: '500',
        letterSpacing: 0.5
    },
    modalTitle: {
        fontSize: FontSizes.medium
    },
    appDetailsContainer: {
        alignItems: 'center',
        marginVertical: 20,
        justifyContent: 'flex-end',
    },
    appDetailsText: {
        fontSize: FontSizes.extraSmall,
        color: MainColors.mediumGray,
        fontWeight: '500',
        letterSpacing: 0.5
    }
});

export default SettingsScreen;